import React from "react";

export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6" data-testid={testid || "page-header"}>
      <div>
        {eyebrow && <div className="text-[11px] uppercase tracking-[0.22em] text-cobalt-600 font-semibold mb-2">{eyebrow}</div>}
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
        {description && <p className="text-sm text-slate-500 mt-2 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", testid, padding = "p-5" }) {
  return (
    <div data-testid={testid} className={`bg-white border border-slate-200 rounded-md ${padding} ${className}`}>
      {children}
    </div>
  );
}

export function Kpi({ label, value, hint, icon: Icon, accent = "cobalt", testid }) {
  const accents = {
    cobalt: "text-cobalt-600 bg-cobalt-50",
    green: "text-emerald-600 bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    rose: "text-rose-600 bg-rose-50",
    blue: "text-sky-600 bg-sky-50",
    slate: "text-slate-600 bg-slate-100",
  };
  return (
    <Card testid={testid} className="hover:-translate-y-0.5 hover:shadow-md transition-all duration-200 min-w-0" padding="p-4 sm:p-5">
      <div className="flex items-start justify-between gap-2">
        <div className="text-[11px] uppercase tracking-[0.15em] text-slate-500 font-semibold truncate flex-1">{label}</div>
        {Icon && <div className={`w-8 h-8 rounded-md flex-shrink-0 flex items-center justify-center ${accents[accent]}`}><Icon size={16}/></div>}
      </div>
      <div className="mt-3 font-heading text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight text-slate-900 font-mono truncate max-w-full" title={String(value)}>
        {value}
      </div>
      {hint && <div className="text-xs text-slate-500 mt-1 truncate">{hint}</div>}
    </Card>
  );
}

export function Empty({ title = "Nothing here yet", description = "", action }) {
  return (
    <div className="border border-dashed border-slate-300 rounded-md p-10 text-center bg-white">
      <div className="font-heading font-semibold text-slate-700">{title}</div>
      {description && <div className="text-sm text-slate-500 mt-1">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
